// extracted by mini-css-extract-plugin
module.exports =  {"container":"KMg6u7s"};